import { PagedList, SearchUserActionHistoryItemResponse } from 'core'

import { Table } from 'common/components'
import { formatDateOnlyTime, parseZoneFormat } from 'common/dateFormatters'

interface UserActionHistoryTableProps {
  userActionHistory?: PagedList<SearchUserActionHistoryItemResponse>
  loadingUserActionHistory: boolean
  onChange?: (filters: { pageNumber: number; pageSize: number; orderColumn: string; orderDescending: boolean }) => any
}

const UserActionHistoryTable = ({
  userActionHistory,
  loadingUserActionHistory,
  onChange,
}: UserActionHistoryTableProps) => {
  const columns: any[] = [
    {
      title: 'Company Id',
      dataIndex: 'companyId',
      key: 'companyId',
      sorter: false,
    },
    {
      title: 'User Id',
      dataIndex: 'userId',
      key: 'userId',
      sorter: false,
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      sorter: false,
    },
    {
      title: 'Method',
      dataIndex: 'method',
      key: 'method',
      sorter: false,
    },
    {
      title: 'Params',
      dataIndex: 'params',
      key: 'params',
      sorter: false,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      render: (text: string, record: any) => (
        <span>
          <div>{record?.createdAt ? parseZoneFormat(record.createdAt) : 'No Date Created '} </div>
          <div>{record?.createdAt ? formatDateOnlyTime(record.createdAt) : ''}</div>
        </span>
      ),
    },
    {
      title: 'Impersonated By',
      dataIndex: 'impersonatedByUserName',
      key: 'impersonatedByUserName',
      sorter: false,
    },
  ]

  const onUserActionHistoryTableChange = (pagination: any, filters: any, sorter: any) => {
    if (onChange) {
      onChange({
        pageNumber: pagination.current,
        pageSize: pagination.pageSize,
        orderColumn: sorter.field || 'createdAt',
        orderDescending: sorter.order !== 'ascend',
      })
    }
  }

  return (
    <Table
      dataSource={userActionHistory?.items}
      onChange={onUserActionHistoryTableChange}
      loading={loadingUserActionHistory}
      columns={columns}
      pagination={{
        total: userActionHistory?.totalItemCount,
        pageSize: userActionHistory?.pageSize,
        current: userActionHistory?.pageNumber,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '80', '100'],
      }}
    />
  )
}

export default UserActionHistoryTable
